import {
  SafetyCertificateFilled,
  SafetyOutlined,
  WarningOutlined
} from "@ant-design/icons";
import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";
import { AuthorisationInfoModal } from "./AuthorisationInfoModal.jsx";
import { colors } from "~/theme/colors.js";

export const AuthorisationIndicator = ({
  aanmelding = {},
  isUser = false,
  canAuthorize = false,
  onAuthorize = (list) => {},
  canRevoke = false,
}) => {
  const [infoModalVisible, setInfoModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  // Close the info modal when the component unmounts or aanmelding changes
  useEffect(() => {
    setInfoModalVisible(false);
  }, [aanmelding.id, aanmelding.authorised]);

  const handleRevoke = async () => {
    setLoading(true);
    try {
      const data = await api.post("aanmeldingen/revoke_authorisation/", {
        aanmelding_id: aanmelding.id,
      });
      data &&
        dispatch({
          type: "AANMELDING_SUCCESS",
          normalizeAsVliegers: false,
          default_vliegers: data.default_vliegers,
          dag_id: data.dag_id,
          ...data,
        });

      // The page will refresh automatically via Redux
    } catch (error) {
      console.error("Revoke failed:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!isUser && !canAuthorize) {
    return null;
  }

  if (aanmelding?.authorised) {
    const displayText =
      aanmelding?.authorised?.limitations || $t("Geautoriseerd");

    return (
      <>
        <div
          className="clickable row"
          style={{ gap: 6 }}
          onClick={() => setInfoModalVisible(true)}
        >
          <SafetyCertificateFilled style={{ color: colors.groen_dark, fontSize: 16 }} />
          <span style={{ fontSize: 12 }}>
            {displayText.length > 30
              ? displayText.substring(0, 27) + "..."
              : displayText}
          </span>
        </div>

        <AuthorisationInfoModal
          visible={infoModalVisible}
          onClose={() => setInfoModalVisible(false)}
          authorisation={aanmelding.authorised}
          pilotName={aanmelding.vlieger?.name}
          canRevoke={canRevoke}
          onRevoke={handleRevoke}
          loading={loading}
        />
      </>
    );
  }

  if (aanmelding.requires_authorisation && canAuthorize) {
    if (!onAuthorize) {
      return (
        <p className="row" style={{ gap: 2 }}>
          <WarningOutlined style={{ color: "#fa8c16" }} />
          {$t("Géén authorisatie")}
        </p>
      );
    }
    return (
      <Button
        type="default"
        size="small"
        icon={<SafetyOutlined />}
        onClick={() => onAuthorize([aanmelding])}
        style={{ borderColor: "#fa8c16", color: "#fa8c16", marginBottom: 6 }}
      >
        {$t("Autoriseer")}
      </Button>
    );
  }

  if (aanmelding.requires_authorisation && !canAuthorize) {
    return (
      <p className="row" style={{ gap: 2 }}>
        <WarningOutlined style={{ color: "#fa8c16" }} />
        {$t("Authorisatie vereist")}
      </p>
    );
  }

  return null;
};
